export const DPC_EVENT_ORIGIN = 'morressier.dpc';

export enum LibraryType {
  Publisher = 'Publisher',
  Organization = 'Organization',
}
